import React from "react";
import { Trans } from "@lingui/macro";
import { useDispatch, useSelector } from "react-redux";
import { ViewDataEdmProductInfo } from "./ViewComponent";
import { useInputChange } from "../../../../hooks/useInputChange";
import { selectPrimaryTenant } from "../../../../model/system/selectors";
import * as ac from "../../../../model/dashboardEdmProducts/dEdmProductsActionCreators";
import { typeProductsFilters } from "../../../../model/dashboardEdmProducts/dEdmProductsReducer";
import { dEdmProductsSetDetailItemAC } from "../../../../model/dashboardEdmProducts/dEdmProductsActionCreators";
import { typePaginationDashboardObject } from "../DashboardContentTable/PaginationDashboard/PaginationDashboard";
import {
  selectFilters,
  selectSearchName,
  selectPaginationObject,
} from "../../../../model/dashboardEdmProducts/selectors";

export type typeDataProductInfo = {
  variant?: string;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export type typeDataProductInfoRowActions = {
  id?: string;
  title: React.JSX.Element;
  action: (id: string) => void;
}[];

export type typeDataProductInfoBulkActions = {
  action: () => void;
  title: React.JSX.Element;
}[];

export const EdmDataProductInfo: React.FC<typeDataProductInfo> = ({
  variant,
  setSidebarOpen,
}) => {
  const dispatch = useDispatch();

  const filters = useSelector(selectFilters);
  const searchName = useSelector(selectSearchName);
  const primaryTenant = useSelector(selectPrimaryTenant);
  const paginationObject = useSelector(selectPaginationObject);

  const [openPopupAdd, setOpenPopupAdd] = React.useState(false);
  const [openPopupEdit, setOpenPopupEdit] = React.useState(false);
  const [openFilterBar, setOpenFilterBar] = React.useState(false);
  const [isActiveFilters, setIsActiveFilters] = React.useState(false);
  const [openPopupDetails, setOpenPopupDetails] = React.useState(false);

  const pagination: typePaginationDashboardObject = {
    paginationObject: paginationObject,
    onGoToPage: (id) => dispatch(ac.dEdmProductsSetPageNumberAC(id)),
    onSelectItems: (itemsPerPage) => {
      return dispatch(ac.dEdmProductsSetItemsForPageAC(itemsPerPage));
    },
  };

  React.useEffect(() => {
    if (primaryTenant) {
      dispatch(
        ac.dEdmProductsSetDataSagaAC(
          filters,
          {
            page: pagination.paginationObject.pageNumber,
            size: pagination.paginationObject.itemsPerPage!,
          },
          primaryTenant,
        ),
      );
    }
  }, [
    filters,
    dispatch,
    primaryTenant,
    pagination.paginationObject.pageNumber,
    pagination.paginationObject.itemsPerPage,
  ]);

  React.useEffect(() => {
    return () => {
      dispatch(ac.dEdmProductsClearFiltersAC());
    };
  }, [dispatch]);

  const {
    value: searchValue,
    setValue: setSearchValue,
    changeValueHandler: onChangeSearchValue,
  } = useInputChange(searchName || "");

  const onClickAdd = () => {
    setOpenPopupAdd(true);
  };

  const onClearSearch = () => {
    dispatch(ac.dEdmProductsSetFiltersAC({ name: null }));

    setSearchValue("");
  };

  const onEnterSearch = () => {
    const filters: typeProductsFilters = {
      name: searchValue.trim(),
    };

    dispatch(ac.dEdmProductsSetFiltersAC(filters));
  };

  return (
    <ViewDataEdmProductInfo
      variant={variant}
      setSidebarOpen={setSidebarOpen}
      //
      onClickAdd={onClickAdd}
      //
      openFilterBar={openFilterBar}
      setOpenFilterBar={setOpenFilterBar}
      //
      openPopupDetails={openPopupDetails}
      setOpenPopupDetails={setOpenPopupDetails}
      //
      openPopupAdd={openPopupAdd}
      setOpenPopupAdd={setOpenPopupAdd}
      //
      openPopupEdit={openPopupEdit}
      setOpenPopupEdit={setOpenPopupEdit}
      //
      searchValue={searchValue}
      onClearSearch={onClearSearch}
      onEnterSearch={onEnterSearch}
      onChangeSearchValue={onChangeSearchValue}
      //
      isActiveFilters={isActiveFilters}
      setIsActiveFilters={setIsActiveFilters}
      //
      pagination={pagination}
      rowsActions={[
        {
          title: <Trans>Edit</Trans>,
          action: (id: string) => {
            dispatch(dEdmProductsSetDetailItemAC(id));

            setOpenPopupEdit(true);
          },
        },
      ]}
      bulkActions={[]}
    />
  );
};
